import invariant from 'tiny-invariant'

export function getFromEnvironment(environmentVariableName: string, fallback?: string): string {
    const value = import.meta.env[environmentVariableName]
    !fallback && invariant(value, `Make sure to specify ${environmentVariableName} in your environment!`)
    return value || fallback
}

export function getBackendRoute(): string {
    return getFromEnvironment('VITE_BACKEND_ROUTE')
}

export function getAwsRegion(): string {
    return getFromEnvironment('VITE_AWS_REGION')
}

export function getAwsUserPoolId(): string {
    return getFromEnvironment('VITE_AWS_COGNITO_USER_POOL_ID')
}

export function getAwsUserPoolWebClientId(): string {
    return getFromEnvironment('VITE_AWS_COGNITO_CLIENT_ID')
}

export function getMapsApiKey(): string {
    return getFromEnvironment('VITE_MAP_API')
}

export function getIsLocalDev(): boolean {
    const env = getFromEnvironment('VITE_ENV')
    return ['local', 'dev'].includes(env)
}

export function getIsLocal(): boolean {
    const env = getFromEnvironment('VITE_ENV')
    return ['local'].includes(env)
}

export function getEnv(): string {
    return getFromEnvironment('VITE_ENV')
}

export function getFrontendVersion(): string | undefined {
    return import.meta.env['VITE_FRONTEND_VERSION'] || undefined
}

export function getIsUAT(): boolean {
    const env = getFromEnvironment('VITE_ENV')
    return ['uat'].includes(env)
}

export function getIsSentryEnabled(): boolean {
    return getFromEnvironment('VITE_SENTRY_ENABLED') === 'true'
}
